export default __webpack_public_path__ + "static/media/header-onboarding-2.050698ac.gif";